//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layer from './layer.vue'
import { FactoryUtils } from "../../utils/FactoryUtils"
import claimsList from "@/views/insurance/insuranceText/claimsText"
import BScroll from 'better-scroll'
    export default {
        name:'serveContentToast',
        data(){
            return {
              showFlag:false,
              title:'',
              cell:[],
              claimsList:[],
              planBScroll:null,
            }
        },
        components: {
          layer,
          claimsList
        },
        mounted(){
           
        },
        methods:{
          showToast(){
            this.showFlag = true;
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
            this.title = '理赔说明'
          },
          close(){
            this.$refs.layerRef.removeTouch()
            this.showFlag = false;
            this.planBScroll = null;
          }
        }
    }
